import React from 'react';
import './footer-style.css';
import fblogo from '../resources/fb.svg';
import iglogo from '../resources/instagram.svg';
import emlogo from '../resources/email.svg';

export default (props) => {
    return (
<div className="Footer">
    <div className="Footer-logoblock">
        <ul>
            <li>
                <a href={props.fb}>
                    <img src={fblogo} alt="facebook" />
                </a>
            </li>
            <li>
                <a href={props.instagram}>
                    <img src={iglogo} alt="instagram" />
                </a>
            </li>
            <li>
                <a href={'mailto:' + props.email}>
                    <img src={emlogo} alt="email" />
                </a> 
            </li>
        </ul>
    </div>
</div>
    );
}



// WEBPACK FOOTER //
// ./src/components/footer.js